import React from 'react';
import { createRoot } from 'react-dom/client';

import CalendarFilter from './components/CalendarFilter/CalendarFilter.jsx';
import CalendarContextProvider from './context/CalendarContext.jsx';
import CalendarResults from './components/CalendarResults/CalendarResults.jsx';

export default class Calendar {
  constructor(element) {
    this.initialState = JSON.parse(element.dataset.initialState);
    if (!this.initialState) return;

    this.root = element.querySelector('.calendar__wrapper');
    this.contentID = element.querySelector('.calendar__results').id;
    const root = createRoot(this.root);

    root.render(
      <CalendarContextProvider config={{ contentId: this.contentID, ...this.initialState.config }} blocks={this.initialState.blocks}>
        <CalendarFilter />
        <CalendarResults />
      </CalendarContextProvider>
    );
  }
}
